export default __webpack_public_path__ + "static/Homepage-Graphic3-e19520e5b324400efe9099cf563c599a.png";